export default __webpack_public_path__ + "static/media/add_more_here_arrow_blue.2b6319a5.svg";